/**
 * Pushes data to the datalayer
 *
 * @param data
 */
function pushToDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push( data );
}

/**
 * Adds an event listener to a trigger to push data to the datalayer
 *
 * @param id
 * @param data
 */
function addButtonClickToDataLayer(el, data, extraDataAttrs) {
  if (el instanceof HTMLCollection) {
    [...el].forEach( (element) => {
      element.addEventListener( 'click', (event) => {
        if (extraDataAttrs) {
          extraDataAttrs.forEach( (attr) => {
            data[attr] = element.getAttribute( attr );
          } );
        }

        pushToDataLayer( data );
      } );
    } );
  } else {
    if (el) {
      el.addEventListener( 'click', (event) => {
        if (extraDataAttrs) {
          extraDataAttrs.forEach( (attr) => {
            data[attr] = element.getAttribute( attr );
          } );
        }

        pushToDataLayer( data );
      } );
    }
  }
}

/**
 * Initializes the custom datalayer pushes
 */
function initCustomDatalayerPushes() {
  // Fraude melden button in header
  addButtonClickToDataLayer( document.getElementById( 'fraude-melden-header' ), {
    'event': 'klik op fraude melden',
  } );

  // Start lesson in hero
  addButtonClickToDataLayer( document.getElementById( 'start-lesson-hero' ), {
    'event': 'klik op start les in hero',
  } );

  // Start lesson 1 in accordions
  addButtonClickToDataLayer( document.getElementById( 'start-lesson-1-accordion' ), {
    'event': 'klik op start les 1 in accordion op home',
  } );

  // Start lesson 2 in accordions
  addButtonClickToDataLayer( document.getElementById( 'start-lesson-2-accordion' ), {
    'event': 'klik op start les 2 in accordion op home',
  } );

  // Start lesson 3 in accordions
  addButtonClickToDataLayer( document.getElementById( 'start-lesson-3-accordion' ), {
    'event': 'klik op start les 3 in accordion op home',
  } );

  // Go to FAQ archive on home
  addButtonClickToDataLayer( document.getElementById( 'go-to-faq-archive-home' ), {
    'event': 'klik op faq archief op home',
  } );

  // Open podcast on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-button-podcast' ), {
    'event': 'beluister podcast',
  } );

  // Open video on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-button-video' ), {
    'event': 'bekijk video',
  } );

  // Share • whatsapp on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-share-whatsapp' ), {
    'event': 'share whatsapp op les',
  } );

  // Share • facebook on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-share-facebook' ), {
    'event': 'share facebook op les',
  } );

  // Share • twitter on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-share-twitter' ), {
    'event': 'share twitter op les',
  } );

  // Share • linkedin on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-share-linkedin' ), {
    'event': 'share linkedin op les',
  } );

  // Share • copy on lesson single
  addButtonClickToDataLayer( document.getElementById( 'lesson-share-copy' ), {
    'event': 'share copy op les',
  } );

  // Bank click in modal
  addButtonClickToDataLayer( document.getElementsByClassName( 'bank-click-fraud-page' ), {
    'event': 'bank-klik-fraud-pagina',
  } );

  // Bank click in footer
  addButtonClickToDataLayer( document.getElementsByClassName( 'bank-click-footer' ), {
    'event': 'bank-klik-footer',
  } );

  // Header quiz button
  addButtonClickToDataLayer( document.getElementById( 'header-quiz-button' ), {
    'event': 'quiz-start-header',
  } );

  // Home quiz button
  addButtonClickToDataLayer( document.getElementById( 'home-quiz-button' ), {
    'event': 'quiz-start-home',
  } );

  // Lesson single quiz button
  addButtonClickToDataLayer( document.getElementById( 'single-lesson-quiz-button' ), {
    'event': 'quiz-start-les-detail',
  } );

  // Quiz select answer
  // Data format: { event: 'quiz-antwoord-selecteren', 'data-answer': 'l1-q1-aA', 'data-shown-question="Shown question" }
  addButtonClickToDataLayer(
    document.getElementsByClassName( 'lesson-question__trigger' ),
    {
      'event': 'quiz-antwoord-selecteren',
    },
    [
      'data-answer',
      'data-shown-question',
      'data-answer-text',
      'data-correct'
    ]
  );

  // Accordion toggle on single lesson
  if (document.body.classList.contains( 'single-lesson' )) {
    addButtonClickToDataLayer(
      document.getElementsByClassName( 'base-lesson-accordion__header' ), {
        'event': 'klik op accordion',
      },
      ['data-accordion-title']
    );
  }

  // Accordion toggle on quiz result
  if (document.body.classList.contains( 'page-template-template-quiz-results' )) {
    addButtonClickToDataLayer(
      document.getElementsByClassName( 'base-lesson-accordion__header' ), {
        'event': 'klik op accordion resultaat',
      },
      ['data-accordion-title']
    );
  }
}

export default {
  init() {
    initCustomDatalayerPushes();
  },
};